import { Box } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { CartItemProps } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartForm/components/CartItem/CartItem';
import { DeleteButton } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartForm/components/CartItemActions/components/DeleteButton';
import { EditButton } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartForm/components/CartItemActions/components/EditButton';
import { CartItemDialogWrapper } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartItemDialog/CartItemDialogWrapper';
import { useCartItemState } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useCartItemState';
import { useTableLayoutStyle } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useTableLayoutStyle';
import { useScreen } from '@/hooks/useScreen';

export const CartItemActions = ({ index, items, cartFormActions }: CartItemProps) => {
  const { sm, md, lg, xl } = useScreen();
  const { actionsWidth } = useTableLayoutStyle();
  const { trigger } = useFormContext();

  const { autoOpenDialog } = useCartItemState({ index, items });

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (autoOpenDialog) setOpen(true);
  }, []);

  const handleOpen = () => {
    cartFormActions.saveInCart();
    setOpen(true);
  };

  const handleDelete = () => {
    cartFormActions.removeItem(index);
    setTimeout(() => {
      trigger();
    }, 300);
  };

  return (
    <Box
      display={'flex'}
      alignItems={'flex-start'}
      justifyContent={items.length > 1 ? 'flex-start' : 'center'}
      position={sm ? 'relative' : 'absolute'}
      top={sm ? 0 : '-8px'}
      right={sm ? 0 : 10}
      flexDirection={sm ? 'row' : 'row-reverse'}
      p={lg ? '20px 0 0 8px' : md ? '20px 0 0 0' : sm ? '22px 0 0 8px' : '16px 0 0 0'}
      gridGap={xl ? 10 : 6}
      width={actionsWidth}
    >
      <EditButton handleClick={handleOpen} />
      {index > 0 && <DeleteButton handleClick={handleDelete} />}
      <CartItemDialogWrapper
        index={index}
        items={items}
        cartFormActions={cartFormActions}
        open={open}
        setOpen={setOpen}
      />
    </Box>
  );
};
